import { Http } from '@/lib/http';

export class ApprovalService extends Http {
  constructor() {
    super();
    this.endpoint = '/settings/loan_origination/loan_approvals/';
  }

  create(obj) {
    return this.httpClient().post(`${this.endpoint}loan-approval-policy`, obj);
  }

  update(obj) {
    return this.httpClient().put(`${this.endpoint}loan-approval-policy`, obj);
  }

  updateApprovalPolicy(obj) {
    return this.httpClient().put(`${this.endpoint}loan-approval-amount`, obj);
  }

  updateLevelActive(obj) {
    return this.httpClient().put(`${this.endpoint}approval-level-active`, obj);
  }

  updateLoanTypeActive(obj) {
    return this.httpClient().put(`${this.endpoint}loan-type-active`, obj);
  }

  findOne(level) {
    return this.httpClient().get(
      `${this.endpoint}loan-approval-policy?level=${level}`
    );
  }

  findAll() {
    return this.httpClient().get(`${this.endpoint}loan-approval-policies`);
  }

  delete(id) {
    return this.httpClient().delete(
      `${this.endpoint}loan-approval-policy/${id}`
    );
  }
}
